import { format } from "date-fns";
import React from "react";

const UnsRow = (props) => {
    const {row} = props;
    const openModelWindow = (row) => {
        const recipient = {...row};
        delete recipient.isChecked;
        props.setSelectedRecipient(recipient);
        props.setShowModelWindow(true)
    }
    return(
        <tr>
            <td>
                <input type="checkbox" name="select-1" checked={row.isChecked} onChange={()=>{props.handleCheckboxChange(row._id)}} />
            </td>
             
            <td>{row.email}</td>  
            <td>{row.unsubscribes?.length ? format(row.unsubscribes[row.unsubscribes.length - 1]['create_time'],'MMM dd, yyyy hh:mm a') : format(row.updated_at,'MMM dd, yyyy hh:mm a')}</td>
            <td>
            <div className="domain-wrap">
                {row.unsubscribes.map((domain,index)=>(<span key={index}>{domain.domain}</span>))}
            </div>
            </td>
            <td className="align-center"><button onClick={()=>{openModelWindow(row)}} className="xs-btn">Delete</button></td>
        </tr>
    );
}

export default UnsRow;